<template>
  <div class="index">
    <div class="common_mbx">
      您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > 留言
    </div>
    <div class="common_wrap">
      <div class="leavemsg_wrap">
        <p class="leavemsg_waring">* 请填写您的留言，收到留言后我们会及时与您沟通！</p>
        <div class="leavemsg_form">
          <div class="input_form clearfix">
            <div class="form_item">
              <span>姓名：</span><input type="text" name="" v-model='name'>
            </div>
            <div class="form_item">
              <span>电话：</span><input type="text" name="" v-model='mobile'>
            </div>
            <div class="form_item">
              <span>邮箱：</span><input type="text" name="" v-model='email'>
            </div>
           
          </div>
           <div class="from_item_textarea">
              <span>留言:</span>
              <textarea v-model='content'></textarea>
            </div>
           <div class="submit" @click='submit'>提 交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      name:'',
      mobile:'',
      email:'',
      content:''
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){
  },
  methods:{
    submit(){
      if(!this.name){
        alertMessage('请填写姓名');
        return false;
      }
      if(!/^1[34578]\d{9}$/.test(this.mobile)){
        alertMessage('请填写电话');
        return false;
      }
      if(!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(this.email)){
        alertMessage('请填写邮箱');
        return false;
      }
      if(!this.content){
        alertMessage('请填写留言');
        return false;
      }
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=comment', this.$qs.stringify({
          username:this.name,
          tel:this.mobile,
          email:this.email,
          content:this.content
        }))
        .then(response => {
          console.log(response);
          alertMessage(response.data.info)
        })
        .catch(error => {
          console.log(error);
        });

    }
  }
}
</script>

<style scoped>
  .common_mbx span{
    cursor: pointer;
  }
 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .leavemsg_wrap{
  width: 812px;
  margin: 0 auto;
 }
 .leavemsg_waring{
  font-size: 14px;
  color: #000;
  margin-bottom: 40px;
 }
 .form_item{
  width: 262px;
  height: 60px;
  line-height: 60px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  font-size: 14px;
  padding-left: 20px;
  float: left;
  margin-right: 13px;
  box-sizing: border-box;
  margin-bottom: 23px;
 }
 .form_item:last-child{
  margin-right: 0;
 }
 .form_item  span{
  vertical-align: middle;
 }
 .form_item input{
  width: 190px;
  vertical-align: middle;
  font-size: 14px;
 }
 .from_item_textarea{
  width: 100%;
  height: 284px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  margin-bottom: 40px;
  padding: 27px 20px;
  box-sizing: border-box;
 }
 .from_item_textarea span{
  vertical-align: top;
  font-size: 14px;
 }
 .from_item_textarea textarea{
  width: 729px;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  border: none;
  resize: none;
  font-size: 14px;
 }
 textarea:focus{
  outline: none;
 }
 .submit{
  width: 192px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  font-size: 18px;
  color: #fff;
  border-radius: 4px;
  background-color: #3478f7;
  margin: 40px auto;
  cursor: pointer;
 }
</style>


// WEBPACK FOOTER //
// src/components/leavemsg.vue